<template>
  <section>
    <header>
      <img src="../assets/images/indexlogo.png" alt="logo" />
    </header>
    <main>
      <el-row>
        <el-col style="margin-top:200px;">
          <span>
            <h1></h1>
          </span>
        </el-col>
      </el-row>
      <el-row class="searchStyle">
        <el-col :span="16" :offset="4">
          <el-input placeholder="请输入企业名称以查询" v-model="keyWord" class="input-with-search">
            <el-button slot="append" @click="searchResult">
              <img src="../assets/images/indexsearch.png" class="searchImg" alt="搜索" />查询
            </el-button>
          </el-input>
        </el-col>
      </el-row>
    </main>
    <footer>Copyright&copy;中国系统集成行业协会版权所有</footer>
  </section>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      keyWord: ""
    };
  },
  methods: {
    searchResult() {
      if (this.keyWord) {
        this.$router.push({ path: "/result", query: { name: this.keyWord } });
      } else {
        this.$message.warning('请输入企业名称');
      }
    }
  }
};
</script>
<style scoped>
header {
  width: 80%;
  height: 180px;
  margin: 0 auto;
  overflow: hidden;
}
header img {
  display: block;
  width: 507px;
  height: 72px;
  margin: 59px auto 0px;
}
main {
  min-width: 800px;
  background: #cccccc;
  height: 640px;
  background-image: url("../assets/images/indexbg.png");
}
main .searchStyle .searchImg {
  width: 20px;
  display: inline-block;
  margin-right: 5px;
  vertical-align: -2px;
}
footer {
  min-width: 800px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #4d4d4d;
}
</style>